import { render, staticRenderFns } from "./Constellations.vue?vue&type=template&id=707d85ad&"
import script from "./Constellations.vue?vue&type=script&lang=js&"
export * from "./Constellations.vue?vue&type=script&lang=js&"
import style0 from "./Constellations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports